import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyDKBYhEByWY-CK53uGb66fNcjvvOjL5Jss',
  authDomain: 'finli-efed8.firebaseapp.com',
  projectId: 'finli-efed8',
  storageBucket: 'finli-efed8.firebasestorage.app',
  messagingSenderId: '536456391206',
  appId: '1:536456391206:web:cf871c0261ad0f0cf0d4e7',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const functions = getFunctions(firebaseApp, 'europe-west2');

void setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn('Failed to set auth persistence', error);
});
